import { useTranslation } from 'react-i18next';
import { useSnackBar } from '../SnackBarContext';
import { useQuery } from 'react-query';
import { QueryKeys } from '../../types';
import { AxiosResponse } from 'axios';
import { FeatureFlagsResponseDto } from '@bandido/shared/dtos';
import { client } from '../../services';

export const useGetFeatureFlags = () => {
  const { addToast } = useSnackBar();
  const { t } = useTranslation();

  return useQuery({
    queryKey: [QueryKeys.getFeatureFlags],
    queryFn: async (): Promise<AxiosResponse<FeatureFlagsResponseDto> | null> => client.get('agency/feature/flag'),
    meta: {
      errorHandler: () =>
        addToast({
          message: t('common.error.server'),
          color: 'error',
        }),
    },
    refetchOnWindowFocus: true,
  });
};
